import { useFormStore } from '@/stores/form'
import apiHelperService from '@/services'
import { useGlobalStore } from '@/stores/global'
import router from '@/router'
import lookups from '@/assets/json/clientLookups.json'

const initForm = () => {
  const formStore = useFormStore()
  const globalStore = useGlobalStore()
  const { serviceTransactionId } = globalStore.startedService
  const { administrativeRegionId = '' } = router.currentRoute.value.query
  const {
    eidaCardDurationId: { fiveYears },
    module: { ICA },
    applicatClassType: { gCC },
    applicationRequestType: { replaceIDCard }
  } = lookups
  formStore.extraMap = {
    ...formStore.extraMap,
    withException: false,
    administrativeRegionId,
    serviceTransactionId,
    showQualificationLevel: false,
    showWorkType: false,
    showChangePersonPhoto: false
  }
  formStore.draft.request = {
    ...formStore.draft.request,
    newIdCardDurationId: fiveYears,
    fileModuleId: ICA,
    applicantClassId: gCC,
    applicationRequestTypeId: replaceIDCard
  }
}

const initInfo = async () => {
  const formStore = useFormStore()
  const res = await apiHelperService.get(`/api/individual/info`)
  if (res) {
    formStore.draft.request.individualInfo = res
  }
}

export default async function () {
  try {
    await initForm()
    await initInfo()
  } catch (error) {
    console.error('use575Preload error: ', error)
  }
}
